/**
 * PostDetailMeta 컴포넌트
 * @description 매거진의 곁글 — 주제 · 글쓴이 · 날짜 · 읽는 시간. **데스크톱에서만** 표제 왼쪽에
 *   실선으로 나뉜 줄들로 서서 스크롤을 따라 붙는다. 폰·태블릿에서는 같은 정보가 표제 위의
 *   눈썹(주제)과 리드 아래의 바이라인(`PostDetailHeader`)으로 갈라진다 — 한 줄에 섞으면
 *   높이가 다른 것들이 어긋나 보였다.
 */
import { memo } from "react";

import PostAuthorAvatar from "./PostAuthorAvatar";
import { postDetailStyles } from "./PostDetail.styles";
import type { PostDetailMetaProps } from "./PostDetail.types";

import { blogCopyOf } from "../../constants/blogCopy";
import { formatPostDate } from "../../utils/formatPostDate";

const PostDetailMeta = memo<PostDetailMetaProps>(({ post, readingMinutes }) => {
  const topic = post.category?.name;
  const styles = postDetailStyles.meta;
  const copy = blogCopyOf(post);

  return (
    <dl className={styles.root}>
      {topic ? (
        <div className={styles.row}>
          <dt className={styles.label}>{copy.meta.topic}</dt>
          <dd className={styles.topic}>{topic}</dd>
        </div>
      ) : null}
      <div className={styles.row}>
        <dt className={styles.label}>{copy.meta.author}</dt>
        <dd className={styles.author}>
          <PostAuthorAvatar author={post.author} />
          <span className={styles.value}>{post.author.name}</span>
        </dd>
      </div>
      <div className={styles.row}>
        <dt className={styles.label}>{copy.meta.date}</dt>
        <dd className={styles.value}>
          <time dateTime={post.publishedAt}>
            {formatPostDate(post.publishedAt)}
          </time>
        </dd>
      </div>
      <div className={styles.row}>
        <dt className={styles.label}>{copy.meta.read}</dt>
        <dd className={styles.value}>{copy.minRead(readingMinutes)}</dd>
      </div>
    </dl>
  );
});

PostDetailMeta.displayName = "PostDetailMeta";

export default PostDetailMeta;
